(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const attach = () => {
      const slider = document.getElementById('Slider-{{ section.id }}');
      if (!slider) return;
      const component = slider.closest('slider-component');
      if (!component || component.dataset.autoCycle === 'true') return;
      const slides = Array.from(slider.querySelectorAll('.slider__slide'));
      if (slides.length <= 4) return;

      const visibleCount = 4;
      const stepDistance =
        slides[visibleCount] && slides[0]
          ? slides[visibleCount].offsetLeft - slides[0].offsetLeft
          : slides[0].clientWidth * visibleCount;

      let currentStart = 0;

      const goTo = (start) => {
        const left = slides[start] ? slides[start].offsetLeft : 0;
        slider.scrollTo({ left, behavior: 'smooth' });
      };

      const tick = () => {
        currentStart = currentStart + visibleCount;
        if (currentStart >= slides.length) {
          currentStart = 0;
        }
        goTo(currentStart);
      };

      let timer = setInterval(tick, 4000);
      const stop = () => {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      };
      const start = () => {
        if (!timer) timer = setInterval(tick, 4000);
      };

      component.addEventListener('mouseenter', stop);
      component.addEventListener('mouseleave', start);
      component.addEventListener('focusin', stop);
      component.addEventListener('focusout', start);

      component.dataset.autoCycle = 'true';
    };

    if (!attach()) {
      document.addEventListener('DOMContentLoaded', attach, { once: true });
      document.addEventListener('shopify:section:load', attach);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  (() => {
    const param = 'filter.v.availability';
    const value = '1';
    const applyFilter = () => {
      const url = new URL(window.location.href);
      const hasParam = url.searchParams.getAll(param).includes(value);
      const key = `availability-applied-${window.location.pathname}`;

      // evita loop: se giù applicato o in design mode con ?filter
      if (!hasParam && !sessionStorage.getItem(key)) {
        url.searchParams.append(param, value);
        sessionStorage.setItem(key, '1');
        window.location.replace(url.toString());
        return;
      }

      // spunta il checkbox se presente
      const tick = () => {
        document
          .querySelectorAll(`input[type="checkbox"][name="${param}"][value="${value}"]`)
          .forEach((el) => (el.checked = true));
      };

      tick();
      document.addEventListener('shopify:section:load', tick);
    };

    document.addEventListener('DOMContentLoaded', applyFilter, { once: true });
  })();

  } catch(e) { console.error(e); }
})();
})();
